import { useDispatch, useSelector } from 'react-redux';
import { CustomerLookupPhone } from 'components';
import { useAgentStatusChange, useProfile } from 'hooks';
import { PERMISSION } from 'utils';
import { checkPermissions } from 'utils/check-permission';
import { setIsCallSelected } from 'store/features/customer-support-session/customer-support-session.slice';
import { RootState } from 'store';

type CustomerLookupCallProps = {};

function CustomerLookupCall({ }: CustomerLookupCallProps) {
  const { userPermissionIds } = useProfile();
  const dispatch = useDispatch();
  const isCallSelected = useSelector((state: RootState) => state.customerSupportSession.isCallSelected);
  const isChatSelected = useSelector((state: RootState) => state.customerSupportSession.isChatSelected);

  const isAllow = checkPermissions(userPermissionIds, PERMISSION.CALL_CUSTOMER);

  // ✅ Add function to handle click with session preservation awareness
  const handleCallSelection = () => {
    console.log('📞 CustomerLookupCall clicked - checking for call data');
    
    // Check for existing call data
    const hasCallData = !!localStorage.getItem('currentCallDialingEvent');
    
    if (!hasCallData) {
        console.log('⚠️ No active call data - switching to empty call mode');
    } else {
        console.log('✅ Call data exists - switching to active call mode');
    }
    
    // Always dispatch the action, the prevention logic is in the parent component
    dispatch(setIsCallSelected(true));
  };

  if (!isAllow) {
    return null;
  }

  // Add onClick handler to container
  return (
    <div onClick={handleCallSelection} className="h-full w-full cursor-pointer">
      <CustomerLookupPhone />
    </div>
  );
}

export default CustomerLookupCall;
